import type { SocialItem, SocialItemServer } from '@metapic-apps/shared'

import type { MoneyServerType, MoneyType } from '@/lib/types'
import type { ProcessableImageType, ProcessableServerImageType } from '@/types/common.types'
import type { CreatorTagServerType, CreatorTagType } from '@/types/creator.types'
import type { UserTag } from '@/types/userTags'

export type ParticipantStatusType =
  | 'suggestion'
  | 'second_prio'
  | 'open'
  | 'applied'
  | 'accepted'
  | 'store_denied'
  | 'denied'
  | 'product_sent'
  | 'have_received'
  | 'have_posted'
  | 'done'

export enum ParticipantStatus {
  Suggestion = 'suggestion',
  SecondPrio = 'second_prio',
  Open = 'open',
  Applied = 'applied',
  Accepted = 'accepted',
  StoreDenied = 'store_denied',
  Denied = 'denied',
  ProductSent = 'product_sent',
  HaveReceived = 'have_received',
  HavePosted = 'have_posted',
  Done = 'done',
}

export type CampaignParticipantServerType = {
  id: string
  offer_id: number
  user_id: number
  display_name: string
  clicks: number
  status: ParticipantStatus
  todo: {
    key: string
    value: boolean
  }[]
  payment_amount: number | null
  payment_amount_v2: MoneyServerType | null
  offer_comments_count: number
  social_media: SocialItemServer[]
  tags: CreatorTagServerType[]
  avatar: string // Legacy, should not be used!
  creator_avatar: ProcessableServerImageType
  has_unread_notifications?: boolean
}

export type CampaignParticipantType = {
  clicks: number
  displayName: string
  id: number | string
  userId: number
  offerCommentsCount?: number
  offerId: number
  status: ParticipantStatus
  todo: { key: string; value: boolean }[] | null
  tags: CreatorTagType[]
  paymentAmount?: number | null
  paymentAmountV2: MoneyType | null
  creatorAvatar?: ProcessableImageType
  productSeedingSpending?: number // not implemented yet
  hasUnreadNotifications?: boolean
  socialMedia: SocialItem[]
}

export type CampaignParticipantDetailsType = {
  clicks: number
  display_name: string
  id: number
  offer_id: number
  payment_amount: null | number
  payment_amount_v2: MoneyServerType | null
  social_media: SocialItemServer[]
  status: ParticipantStatus
  tags: UserTag[]
  todo: { key: string; value: boolean }[]
  user_id: number
  activity?: (ActivityDeletedCommentType | ActivityCommentType | ActivityStatusChangeType)[]
  creator_avatar?: ProcessableServerImageType
}
type CommonActivityType = {
  has_unread_notification?: boolean
}
export type AvatarDataType = {
  abbreviation: string
  color: string
}

export type ActivityDeletedCommentType = {
  type: 'DELETED_COMMENT'
  created_at: string
  actor_display_name?: string
  actor_is?: number
} & CommonActivityType

export type ActivityCommentType = {
  type: 'COMMENT'
  created_at: string
  updated_at: string
  actor_id: number
  actor_display_name?: string
  comment_text: string
  comment_id: number
} & CommonActivityType

export type ActivityStatusType =
  | 'open'
  | 'go'
  | 'applied'
  | 'denied'
  | 'accepted'
  | 'store_denied'
  | 'done'
  | 'have_posted'
  | 'have_received'
  | 'send_product'
  | 'suggestion'

export type ActivityStatusChangeType = {
  type: 'STATUS_CHANGE'
  created_at: string
  old_status?: ParticipantStatus
  new_status: ParticipantStatus
  actor_id?: number
  actor_display_name?: string
} & CommonActivityType
